import React from "react";
import { Quote } from "lucide-react";
import Reveal from "./Reveal";

const accentMap = {
  orange: "#FF6C10",
  blue: "#187EE4",
  red: "#FF1228",
};

const Testimonial = ({ data }) => {
  const color = accentMap[data.accent] || "#187EE4";
  return (
    <section className="bg-white py-10 md:py-14">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <Reveal>
          <div
            className="relative rounded-3xl px-7 py-10 md:px-12 md:py-12 text-center overflow-hidden"
            style={{ backgroundColor: "rgba(24,126,228,0.05)", border: `2px solid ${color}22` }}
          >
            <div
              className="inline-flex items-center justify-center w-14 h-14 rounded-full mb-5"
              style={{ backgroundColor: color }}
            >
              <Quote className="w-7 h-7 text-white" fill="white" strokeWidth={0} />
            </div>
            <p className="text-xl md:text-2xl text-slate-700 font-bold leading-relaxed">
              “{data.quote}”
            </p>
            <p className="mt-6 font-display text-lg" style={{ color }}>
              – {data.author}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonial;
